import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ behavior = 'smooth', delay = 0 }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Small delay to ensure page content is loaded
    const scrollTimer = setTimeout(() => {
      // Scroll to top when route changes
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior
      });
    }, delay);

    // Cleanup timer on unmount or path change
    return () => clearTimeout(scrollTimer);
  }, [pathname, behavior, delay]);

  return null;
};

export default ScrollToTop; 